import { trackAppEvent } from "./monitoring/appInsights";
import { recoverTokenInfo } from "./recoverTokenInfo";
import { toLogProperties } from "./logProperties";

export type EventReportOptions = {
  eventName: string;
  properties?: Record<string, unknown>;
};

export const reportEvent = async (message: string, options: EventReportOptions) => {
  const properties = toLogProperties({
    message,
    user: recoverTokenInfo("ibabs-user-id"),
    url: typeof window !== "undefined" ? window.location.href : undefined,
    path: typeof window !== "undefined" ? window.location.pathname : undefined,
    userAgent: typeof navigator !== "undefined" ? navigator.userAgent : undefined,
    language: typeof navigator !== "undefined" ? navigator.language : undefined,
    mode: import.meta.env.MODE,
    ...options.properties,
  });

  trackAppEvent(options.eventName, properties);
};

// The only business events allowed to reach Application Insights as custom events (ECSIBABS-5886).
// Everything else can still be logged (console/exception), just not as a custom event.
export const BUSINESS_EVENT_NAMES = [
  "MICROPHONE_PERMISSION_GRANTED",
  "MICROPHONE_CAPTURE_STARTED",
  "MICROPHONE_CAPTURE_DISCARDED",
  "MICROPHONE_CAPTURE_PAUSED",
  "MICROPHONE_CAPTURE_RESUMED",
  "MICROPHONE_CAPTURE_STOPPED",
  "MEDIA_UPLOADED",
] as const;

export type BusinessEventName = (typeof BUSINESS_EVENT_NAMES)[number];

export const SERVICE_NAME = "SmartDebrief.Frontend";

export type BusinessEventProperties = { RecordingId?: string; [key: string]: unknown };

export const trackBusinessEvent = (eventName: BusinessEventName, properties: BusinessEventProperties = {}) =>
  reportEvent(eventName, {
    eventName,
    properties: {
      EventDate: new Date().toISOString(),
      ServiceName: SERVICE_NAME,
      AppVersion: __APP_VERSION__,
      ...properties,
    },
  });
